import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

import { AuthProvider } from './context/AuthProvider';
import { SelectionsProvider } from './context/SelectionsProvider';

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import {
  QueryClient,
  QueryClientProvider
} from '@tanstack/react-query';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60_000,
      cacheTime: 60 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    }
  }
});


const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
  <QueryClientProvider client={queryClient}>
    <Router>
      <AuthProvider>
        <SelectionsProvider>
          <Routes>
            <Route
              path="/*"
              element={<App />}
            />
          </Routes>
        </SelectionsProvider>
      </AuthProvider>
    </Router>
  </QueryClientProvider>
);


reportWebVitals();